const INTEGER_FORMAT = new Intl.NumberFormat("en-US")

export function formatInteger(value: number | null | undefined): string {
  if (value == null) return "—"
  return INTEGER_FORMAT.format(value)
}
